import { render } from "./SectionInclude.vue?vue&type=template&id=95fe2adc&scoped=true"
import script from "./SectionInclude.vue?vue&type=script&lang=js"
export * from "./SectionInclude.vue?vue&type=script&lang=js"

import "./SectionInclude.vue?vue&type=style&index=0&id=95fe2adc&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95fe2adc"]])

export default __exports__